
module dg.lists {

    import ListQuery = dg.domain.queries.ListQuery;
          
    class FilterActionListController {

        public constructor(
            private $element: ng.IAugmentedJQuery,
            //private $transclude: any,
            private $scope: ng.IScope,
            private $document: ng.IDocumentService
        ) {
            //this.$transclude((transcludeEl) => {
            //    this.$element.find('.content2').append(transcludeEl);
            //});
        }

        public isOpen: boolean;
        private isSearchBtnClicked: boolean;
        //public query: ListQuery<dg.domain.IDomainObject>;
        public get query() {
            return this.queryManipulator.query;
        }

        
        public exclude: Array<string> = ['pageNumber', 'pageSize', 'pattern'];
        private options: any;
        private chartTemplateUrlTemp: string;
        private queryManipulator: dg.actions.ServerQueryManipulator;
        private documentCloseEventListener;
        
       // private $timeout: ng.ITimeoutService;



        $onInit () {          
            //this.query = this.queryManipulator.query();

            this.isSearchBtnClicked = false;
        }

        private addDocumentClickListener(onDocumentClickFunc) {
            this.documentCloseEventListener = onDocumentClickFunc;
            this.$document.on('click', onDocumentClickFunc);
        }
        private removeDocumentClickListener(){
            if (this.documentCloseEventListener) {
                this.$document.off('click', this.documentCloseEventListener);
                this.documentCloseEventListener = null;
            }
        }
        public toggleFilter (open) {
            if (open) {
                
                this.isSearchBtnClicked = false;

                let onDocumentClickFunc = (event: Event) => {     
                        if (this.$element.find(event.target).length == 0 &&
                            angular.element(event.target).parents('[uib-datepicker]').length == 0
                            && angular.element(event.target).parents('[uib-dropdown-menu]').length == 0
                            //&& (angular.element(event.target).parents('.daterangepicker').length == 0
                            && angular.element('.uib-dropdown-menu').css('display') != 'block') {
                            this.removeDocumentClickListener();
                            this.$scope.$apply(() => {
                                this.closeFilters();
                            });
                        
                        }
                };
                this.addDocumentClickListener(onDocumentClickFunc);
            } else if (!this.isSearchBtnClicked) {
                //_.merge(this.query, this.originalQuery);
                this.queryManipulator.revertQuery();
                this.removeDocumentClickListener();
            }
        }

        public closeFilters = () => {
            this.isOpen = false;
            this.removeDocumentClickListener();
            //close dropdown by click outside the dropdown-menu
            //this.$document.trigger('click');
        }


        public clearFilter = () => {
            this.queryManipulator.resetQuery();
        }

        public searchClick = () => {

            this.isSearchBtnClicked = true;
            this.queryManipulator.resetPaging();
            this.queryManipulator.executeQuery();
            this.closeFilters();
        };
    }

    angular.module('dg.lists').component('filterActionList', {
        bindings: {
            options: '=',
            queryManipulator: '<'
        },
        controller: FilterActionListController,
        templateUrl: '/digmo/src/lists/filter-action-list.html'
    });
}